import { useTheme } from 'styled-components';
import { noAnalyticsSlot } from '../common/NoAnalyticsCacheKey';
import { useRouter } from '../common/hooks/useRouter';
import { useFlags } from '../common/services/flags';
import { env } from '../common/util/env';
import { useOptionalPreloadSlot } from './preloader/PreloadSlot';
const { ADOBE_LAUNCH, ADOBE_LAUNCH_PATIENT } = env;

export const AdobeLaunchInstaller = () => {
  const router = useRouter();
  const disableAnalytics = useOptionalPreloadSlot(noAnalyticsSlot);
  const { whiteLabelProps } = useTheme();
  if (useFlags().noLaunch) return null;
  if (disableAnalytics) return null;

  if (whiteLabelProps?.adobeLaunchUrl !== undefined) {
    return <script src={whiteLabelProps?.adobeLaunchUrl} async />;
  }

  if (router?.pathname.startsWith('/my-account/')) {
    return <script src={ADOBE_LAUNCH_PATIENT} async />;
  }

  return <script src={ADOBE_LAUNCH} async />;
};
